import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const DivButtonsContainerStyled = styled('div', {
  name: 'DivButtonsContainerStyled',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
}));

export const ContainerBox = styled(Box, {
  name: 'ContainerBox',
})(({ theme }) => ({
  marginTop: theme.spacing(1),
  overflow: 'auto',
  outline: `1px solid ${alpha(theme.palette.secondary.main, 0.6)}`,
  borderRadius: '4px',
}));
